import MdaeList from "./component";
import { IListOptions } from "devextreme-react/list";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeListProps extends IListOptions {
  id: string;
  mdaeListTitle?: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeList;
